import { Component } from '@angular/core';
import { UploadArqService } from 'src/app/service/upload-arq.service'
import { ApiService } from '../services/contratos/contratos.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Component({
    selector: 'app-time-table-model',
    templateUrl: './time-table-model.component.html',
    styleUrls: ['./time-table-model.component.css'],
    standalone: false
})
export class TimeTableModelComponent {

  selectedFile: File | null = null;

  constructor(private s3UploadService: UploadArqService,
    private dynamodbService: ApiService,
    private http: HttpClient
  ) { }

  async ngOnInit() { 

  }

  onFileSelected(event: any): void {
    this.selectedFile = event.target.files[0];
  }

  async redirecionar() {
    const result3 = await this.getPresignedURL();
    // console.log(result3)
    // Substitua 'sua_url' pela URL para a qual deseja redirecionar
    window.location.href = result3;
}


  onUpload(): void {
    if (this.selectedFile) {
      const fileName = this.selectedFile.name;
      // console.log(fileName);
      this.s3UploadService.uploadFileWithParameters(
        'fileupload-eps', // Substitua pelo seu bucket
        fileName,
        'get' // Substitua pelo seu valor de ação
      ).subscribe(
        () => {
          console.log('Upload concluído com sucesso.');
        },
        (error) => {
          console.error('Erro ao fazer upload:', error);
        }
      );
    }
  }

  async getPresignedURL(): Promise<any> {
    try {
      const response = (await this.s3UploadService.getURL("https://gtjymz35xb.execute-api.sa-east-1.amazonaws.com/v1/"));
      // console.log(response)
      if (response) {
         return response;       
      } else {
        console.error('Invalid response:', response);
        return null;
      }
    } catch (error) {
      console.error('Error processing data:', error);
      return null;
    }
  }
}
